import reduxConstants from "../../utils/redux/constant.js";

export default reduxConstants("deductions", [
  "CLEAR_DEDUCTIONS",
  "SET_DEDUCTIONS",
  "SET_DEDUCTION_CARDS",
  "SET_FILTER",
  "SET_FILTER",
  "SET_SORT_BY",
  "SET_SORT_DIRECTION",
]);
